module.exports = {"error_login_failed":{"title":"Login failed","confirm":"OK"},"success_logout":{"title":"Logout successful","content":"We hope to see you soon!","confirm":"OK"},"update_available":{"title":"Update Available: {{update_version}}","content":"You are running an outdated version of Festzelt OS in your browser, so we cannot proceed. Please reload this page to continue. If this warning persists, try clearing your browser cache. We generally recommend using Chrome as a browser.","confirm":"Reload page now","cancel":"Refresh later"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/auth.json
// module id = 2386
// module chunks = 1